export default "__VITE_ASSET__6eQJJ136__"